export default {
  // 通用
  ok: '确定',
  cancel: '取消',
  send: '发送',
  // 时间
  timeJustNow: '刚刚',
  timeMinutesAgo: '{n}分钟前',
  timeHoursAgo: '{n}小时前',
  timeYesterday: '昨天',
  // 聊天工具栏 title
  chatEmotion: '表情',
  chatSendImage: '发送图片',
  chatSendFile: '发送文件',
  chatReceipt: '回执消息',
  chatSendVoice: '发送语音',
  chatGroupInfo: '群聊信息',
  // 聊天区
  chatSomeoneAtMe: '有人@我',
  chatNewMessages: '{n}条新消息',
  chatBackToBottom: '回到底部',
  chatReceiptPrefix: '【回执消息】',
  // 消息操作/提示
  chatNoMoreMessages: '没有更多消息了',
  chatDeleteConfirm: '确认删除消息?',
  chatDeleteTitle: '删除消息',
  chatRecallConfirm: '确认撤回消息?',
  chatRecallTitle: '撤回消息',
  chatRecalled: '消息已撤回',
  chatLocateFail: '无法定位原消息',
  chatResendUnsupported: '该消息不支持自动重新发送，建议手动重新发送',
  // 输入框禁用提示
  chatGroupDissolved: '群聊已解散',
  chatGroupQuit: '您已不在群聊中',
  chatGroupBanned: '群聊已被封禁',
  chatUserBanned: '对方账号已被封禁',
  chatBanReason: '，原因：',
  // 消息状态/已读
  msgReaded: '已读',
  msgUnread: '未读',
  msgAllReaded: '全体已读',
  msgSomeReaded: '{n}人已读',
  msgSending: '发送中',
  msgSendFail: '发送失败',
  msgRecall: '重新呼叫',
  msgMenuDelete: '删除',
  msgMenuRecall: '撤回',
  // 语音录制
  recordTitle: '语音录制',
  recordDuration: '时长',
  recordStart: '开始录音',
  recordPause: '暂停录音',
  recordResume: '继续录音',
  recordStop: '结束录音',
  recordPlay: '播放录音',
  recordStopPlay: '停止播放',
  recordRestart: '重新录音',
  recordSend: '立即发送',
  recordStateReady: '未开始',
  recordStateRunning: '正在录音...',
  recordStatePaused: '已暂停录音',
  recordStateStopped: '已结束录音',
  msgReadedTab: '已读({n})',
  msgUnreadTab: '未读({n})',
  // 语言
  langLabel: '语言',
  langZh: '中文',
  langEn: 'English'
}
